<template>
  <div class="diet-container">
    <div class="list">
      <div class="day-item" v-for="(item, index) in data" :key="index">
        <div class="day-title">{{ item.time }}</div>
        <div class="day-list">
          <div
            class="diet-item"
            v-for="(item1, index1) in item.list"
            :key="index1"
            @click="bindClick(item1)"
          >
            <img class="image" :src="dealImageStr(item1.content)" alt="" />
            <div class="name">{{ item1.name }}</div>
            <div
              class="score"
              v-if="item1.p_average_score || item1.p_average_score === 0"
              >{{ item1.p_average_score }}分</div
            >
            <div class="iconfont icon-you"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="not-data" v-if="loaded && !data.length">暂无数据</div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loaded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  filters: {},
  methods: {
    bindClick(item) {
      console.log(item)
      if (this.$http._isApp()) {
      } else {
        if (item.version_type == 2) {
          wx.miniProgram.navigateTo({
            url:
              '/package-ugc/pages/dynamic-detail-v2/index' +
              '?tab_type=weapp_group' +
              '&tid=' +
              item.id
          })
        } else {
          wx.miniProgram.navigateTo({
            url:
              '/package-ugc/pages/dynamicDetail/dynamicDetail' +
              '?tab_type=weapp_group' +
              '&tid=' +
              item.id
          })
        }
      }
    },
    dealImageStr(str) {
      let arr = str.split(',')
      return arr[0] || ''
    }
  }
}
</script>
<style lang="scss" scoped>
.diet-container {
  .list {
    .day-title {
      padding: 0px 16px;
      box-sizing: border-box;
      height: 24px;
      background: #f7f7f7;
      border-radius: 4px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.7);
      line-height: 24px;
      margin-bottom: 10px;
    }
    .day-list {
      .diet-item {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .image {
          width: 36px;
          height: 36px;
          border-radius: 4px;
          overflow: hidden;
          margin-right: 10px;
          object-fit: cover;
        }
        .name {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 26px;
        }
        .score {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #6236ff;
          line-height: 26px;
          margin-right: 10px;
        }
      }
    }
  }
}
.not-data {
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}
</style>
